import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import classNames from 'classnames';
import Box from "../Box";
import Card from "../Card";

var getDialogWidth = function getDialogWidth(width) {
  switch (width) {
    case 'small':
    case 'medium':
    case 'large':
    case 'xlarge':
      return '100%';

    default:
      return width;
  }
};

var getDialogMaxWidth = function getDialogMaxWidth(maxWidth, width) {
  switch (width) {
    case 'small':
      return '320px';

    case 'medium':
      return '448px';

    case 'large':
      return '600px';

    case 'xlarge':
      return '896px';

    default:
      return maxWidth;
  }
};

export var Dialog = function Dialog(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? '700px' : _ref$maxWidth,
      _ref$minWidth = _ref.minWidth,
      minWidth = _ref$minWidth === void 0 ? '296px' : _ref$minWidth,
      size = _ref.size,
      style = _ref.style,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 'small' : _ref$width;
  var classes = classNames('Dialog', className);
  return /*#__PURE__*/React.createElement(Card, {
    className: classes,
    role: "dialog",
    shadow: "medium",
    radius: "all",
    style: _objectSpread({}, style, {
      width: getDialogWidth(width),
      maxWidth: getDialogMaxWidth(maxWidth, width),
      minWidth: minWidth
    })
  }, /*#__PURE__*/React.createElement(Box, {
    className: "Dialog-column",
    flex: {
      direction: 'column'
    }
  }, children));
};